const AccountStatus = {
  MANAGER: "MANAGER",
  VERIFIED_MEMBER: "VERIFIED_MEMBER",
  UNVERIFIED_MEMBER: "UNVERIFIED_MEMBER",
  PENDING_MEMBER: "PENDING_MEMBER",
  PROFILE_ONLY: "PROFILE_ONLY",
  MEMBER: "MEMBER",
};
export default Object.freeze(AccountStatus);
